import moment from 'moment';
import { QueryParamConfig } from 'use-query-params';
import { isTimezoneBehindUTC } from './time-utils';

export const CustomDateParam: QueryParamConfig<
  Date | null | undefined,
  Date | null | undefined
> = {
  encode: (date) => {
    if (!date) return undefined;
    if (isTimezoneBehindUTC()) {
      return moment.utc(date).format(`YYYY-MM-DD`);
    }
    return moment(date).format(`YYYY-MM-DD`);
  },
  decode: (input) => {
    if (!input || typeof input !== `string`) return undefined;
    if (isTimezoneBehindUTC()) {
      return moment.utc(input).local().toDate();
    }
    return moment(input, `YYYY-MM-DD`).toDate();
  },
};
